import { sortBy as _sortBy } from 'lodash-es';

type GroupMember = {
  role?: string;
  group?: { id: string };
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const sortGroupsByRelevance = <T extends Record<string, any>>(
  groups: T[],
  groupMembers: GroupMember[] = [],
): T[] => {
  const roleByGroupId = new Map(
    groupMembers
      .filter((gm) => gm.group)
      .map((gm) => [gm.group!.id, gm.role]),
  );
  return _sortBy(groups, (group: T) => [
    roleByGroupId.get(group.id) === 'OWNER' ? 0 : 1,
    -((group.upcomingEventsCount || 0) + (group.recentPostsCount || 0)),
    group.name,
  ]) as T[];
};
